/** Feature-flag CDN origin. Exposed for `<link rel="preconnect">` hints. */
export const FEATURE_FLAGS_API_HOST = 'https://cdn.growthbook.io'

/** Longest any load waits (flags payload, Segment id) before defaults apply. */
export const DEFAULT_LOAD_TIMEOUT_MS = 3000
